var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"orgmap-data-loading-wrapper"},[_vm._v(" "+_vm._s(_vm.$t('조직도_불러오는중'))+"... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }